import { getHighestZIndex } from "@common/utils/DOM";
import indeterminateProgress from "@components/Progress.Indeterminate.vue";
export default {
  components: {
    indeterminateProgress
  },
  props: {
    id: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: undefined
    },
    loading: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    },
    backdrop: {
      type: [String, Boolean],
      default: true
    },
    headless: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: "500px"
    },
    closeButton: {
      type: [String, Boolean],
      default: true
    }
  },
  data() {
    return {
      isOpen: false,
      status: "closed",
      fallbackId: ""
    };
  },
  mounted() {
    // Avoid z-index cascade conflicts
    document.body.append(this.$el);
    let context = this;
    $(this.$el).on("show.bs.modal", function bsEvent() {
      context.isOpen = true;
      context.status = "opening";
      context.$emit("show");
    });
    $(this.$el).on("shown.bs.modal", function bsEvent() {
      context.isOpen = true;
      context.status = "open";
      context.$emit("shown");
      const backdrop = context.$el.nextElementSibling;
      if (backdrop?.classList.contains('modal-backdrop')) backdrop.style.zIndex = getHighestZIndex('.base-dialog, .modal') - 1;
    });
    $(this.$el).on("hide.bs.modal", function bsEvent() {
      context.isOpen = false;
      context.status = "closing";
      context.$emit("hide");
    });
    $(this.$el).on("hidden.bs.modal", function bsEvent() {
      context.isOpen = false;
      context.status = "closed";
      context.$emit("hidden");
      const backdrop = context.$el.nextElementSibling;
      if (backdrop?.classList.contains('modal-backdrop')) backdrop.style.zIndex = null;
    });
  },
  watch: {
    loading(val) {
      this.restrictClose(val);
    },
    locked(val) {
      this.restrictClose(val);
    },
    status(val) {
      this.$emit(val);
    }
  },
  methods: {
    open(e) {
      if (e && e.preventDefault) e.preventDefault();
      $("[data-toggle=\"tooltip\"], .tooltip").tooltip("hide");
      this.$el.style.zIndex = getHighestZIndex('.base-dialog, .modal') + 1;
      $(this.$el).modal("show");
    },
    close(e) {
      if (e && e.preventDefault) e.preventDefault();
      $(this.$el).modal("hide");
      this.$el.style.zIndex = undefined;
    },
    restrictClose(isRestricted) {
      if ($(this.$el).data("bs.modal")?._config) {
        $(this.$el).data("bs.modal")._config.backdrop = isRestricted ? "static" : this.backdrop;
        $(this.$el).data("bs.modal")._config.keyboard = !isRestricted;
      }
    }
  }
};